import MessagesIcon from '@assets/vectors/messages.inline.svg';

import QuickLink from '.';

const Messages: QuickLink = ({ header, description }) => {
	return {
		Icon: MessagesIcon,
		header,
		description,
		pathName: `/app/zendesk_sso?return_to=${process.env.GATSBY_SUPPORT_LINK}/requests`,
	};
};

export default Messages;
